import { routes } from '@constants';
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import CourseCardGradient from '@pngs/CoursesPage/CourseCardGradient.png';
import { Button, Flex, theme, Typography } from '@styles';
import { ReactComponent as EyeIcon } from '@svgs/eye.svg';
import { bool, number, string } from 'prop-types';
import React from 'react';

import { useOfflineImage } from '../../hooks/useOfflineImage';
import { Icon } from '../Icon';

const ArticleCard = ({
  articleId,
  articleImage,
  isRead,
  isWithBooklet,
  titleText,
  wasSeenCount,
}) => {
  const { navigate } = useNavigateWithOfflineMode();
  const { isLaptop, isMobile } = useScreenSize();
  const articleOfflineImageSrc = useOfflineImage(articleImage);

  const handleNavigateButtonClick = () => {
    navigate(`${routes.activities}/${routes.article}`, {
      state: { articleId, isWithBooklet },
    });
  };

  return (
    <Button
      height={isLaptop ? 366 : 450}
      onClick={handleNavigateButtonClick}
      p={0}
      variant="textButton"
      width={isMobile ? '100%' : 'calc(50% - 2px)'}
    >
      <Flex
        backgroundImage={articleOfflineImageSrc || articleImage}
        backgroundSize="cover"
        flexDirection="column"
        height="100%"
        width="100%"
      >
        <Flex
          backgroundImage={CourseCardGradient}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          flexDirection="column"
          height="100%"
          justifyContent="flex-end"
          width="100%"
        >
          <Flex flexDirection="column" pb={2} px={3}>
            <Typography
              color={isRead ? theme.colors.white[60] : theme.colors.white[100]}
              pb={10}
              textAlign="left"
              variant="MS-semibold-s18-lh27"
            >
              {titleText}
            </Typography>
            <Flex>
              <Icon color={theme.colors.alto[100]} mr={2} SVG={EyeIcon} />
              <Typography
                color={theme.colors.white[100]}
                variant="MS-regular-s14-lh22"
              >
                {wasSeenCount}
              </Typography>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Button>
  );
};

ArticleCard.propTypes = {
  articleId: string.isRequired,
  articleImage: string.isRequired,
  isRead: bool.isRequired,
  isWithBooklet: bool,
  titleText: string.isRequired,
  wasSeenCount: number.isRequired,
};

ArticleCard.defaultProps = {
  isWithBooklet: false,
};

export default ArticleCard;
